var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBirthdayHat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8537 5.78924C13.4792 5.46088 13.9085 4.78298 13.9085 4C13.9085 2.89543 13.0541 2 12 2C10.9459 2 10.0914 2.89543 10.0914 4C10.0914 4.783 10.5208 5.4609 11.1463 5.78925L8.45337 11.4331C10.5756 11.0284 12.656 10.4099 14.6653 9.58588L12.8537 5.78924Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88507 16.8157C9.60736 16.4145 13.2395 15.3624 16.6299 13.7034L15.5221 11.3817C12.9113 12.4679 10.1854 13.225 7.40207 13.6364L5.88507 16.8157Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88452 18.9127L4.10198 20.5528C3.78473 21.2177 4.24612 22 4.95551 22H19.0445C19.7539 22 20.2153 21.2177 19.898 20.5528L17.4837 15.4929C13.5249 17.4373 9.25303 18.5982 4.88452 18.9127Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthdayHat);
export default __webpack_public_path__ + "static/media/birthday-hat.2c1eea50a78da39806879cb5a6a8d35c.svg";
export { ForwardRef as ReactComponent };